import React from "react";
import styled from "styled-components";
import { IMusic } from "../../../common/commonTypes";
import Card from "../../../common/components/Card/Card";
import { Truncate } from "../../../common/components/styled";
import { Heading6Bold } from "../../../common/Typography/Heading6";
import { Paragraph16Regular } from "../../../common/Typography/Paragraph16";
import { getPreviewSrc } from "../../../helpers/musicHelper";
import { getAbsoluteFill } from "../../../common/styles";
import Cover from "../../../common/components/Cover";
import { IMAGE_SIZES } from "../../../constants/imageSizes";
import LocalPlayerCard from "../../../common/components/LocalPlayerCard/LocalPlayerCard";

const Root = styled.div`
  padding-bottom: 25px;
  border-bottom: 2px solid ${(props) => props.theme.borderColor};
  margin-bottom: 25px;
`;

const StyledCard = styled(Card)``;

const PlayerPlaceholder = styled.div`
  position: relative;
  width: 100%;
  padding-top: 100%;
  overflow: hidden;
  background-color: ${({ theme }) => theme.lightBackgroundColor};
  border-radius: ${(props) => props.theme.borderRadius.md};
  box-shadow: 0 10px 30px 0 #00000080;
`;

const Player = styled.div`
  ${getAbsoluteFill};
`;

const StyledPlayerCard = styled(LocalPlayerCard)`
  width: 100%;
  height: 100%;
`;

const TrackName = styled(Heading6Bold)`
  margin-top: 29px;
`;

const ArtistName = styled(Paragraph16Regular)``;

interface Props {
  music?: IMusic;
}

const MusicPreview = ({ music }: Props) => {
  const audioSrc = getPreviewSrc(music);
  const coverUrl = music?.cover?.url;

  const renderPlayerPreview = () => {
    if (music && audioSrc) {
      return <StyledPlayerCard music={music} />;
    }

    if (coverUrl) {
      return (
        <Cover
          url={coverUrl}
          mime={music?.cover?.mime}
          size={IMAGE_SIZES.trackCoverArt.big}
        />
      );
    }

    return null;
  };

  return (
    <Root>
      <StyledCard>
        <PlayerPlaceholder>
          <Player>{renderPlayerPreview()}</Player>
        </PlayerPlaceholder>
        <Truncate>
          <TrackName>{music?.title}</TrackName>
        </Truncate>
        <Truncate>
          <ArtistName>{music?.artist?.username}</ArtistName>
        </Truncate>
      </StyledCard>
    </Root>
  );
};

export default MusicPreview;
